import { GridData } from '../index';

export function buildTreeData(data: GridData, dataKey: string): GridData {
    const byId = new Map<string | number, any>();
    const roots: any[] = [];

    data.forEach((row) => {
        byId.set((row as any)[dataKey], { ...row });
    });

    // Helper to check if attaching childId as a descendant of parentId would create a cycle
    const wouldCreateCycle = (childId: string | number, parentId: string | number): boolean => {
        let currentId: string | number | undefined = parentId;
        let depth = 0;
        const maxDepth = 1000;

        while (currentId !== undefined && currentId !== null && depth < maxDepth) {
            if (currentId === childId) {
                return true; // Cycle detected
            }
            const currentNode = byId.get(currentId);
            if (!currentNode) break; // Parent not found, stop walking
            currentId = (currentNode as any).parentId;
            depth++;
        }
        return false;
    };

    data.forEach((row) => {
        const id = (row as any)[dataKey];
        const node = byId.get(id);
        const parentId = (row as any).parentId;

        if (parentId !== undefined && parentId !== null && byId.has(parentId) && !wouldCreateCycle(id, parentId)) {
            const parent = byId.get(parentId);
            parent.children = parent.children ?? [];
            parent.children.push(node);
        } else {
            roots.push(node);
        }
    });

    return roots as GridData;
}
